// The existing nine sections remain the data/validation contract.
export const preparationBlocks = ['Empresa', 'Ofertas', 'Atendimento', 'Assistente', 'Revisão'] as const;
export const blockSections: readonly (readonly number[])[] = [[0], [1, 2], [3, 4, 6, 7], [5], [8]];
export function blockForSection(section: number): number {
  const index = blockSections.findIndex(sections => sections.includes(section));
  return index < 0 ? 0 : index;
}
export function blockStart(block: number): number { return blockSections[block]?.[0] ?? 0; }
